import { useEffect, useState } from 'react'
import { apiErrorMessage } from '@/services/team-service'

export type LoadState<T> =
  | { status: 'loading' }
  | { status: 'ok'; data: T }
  | { status: 'error'; message: string }
  | { status: 'forbidden' }

function isForbidden(error: unknown): boolean {
  return (error as { response?: { status?: number } })?.response?.status === 403
}

/**
 * Carrega um bloco da tela Hoje de forma independente: um bloco que falha
 * (ou que a pessoa não pode ver, 403) não derruba os outros.
 * `key` muda → recarrega (ex.: versão da gaveta de tarefas).
 */
export function useHojeLoader<T>(load: () => Promise<T>, key: unknown = null): LoadState<T> {
  const [state, setState] = useState<LoadState<T>>({ status: 'loading' })
  useEffect(() => {
    let alive = true
    load()
      .then((data) => alive && setState({ status: 'ok', data }))
      .catch((error) => {
        if (!alive) return
        setState(isForbidden(error) ? { status: 'forbidden' } : { status: 'error', message: apiErrorMessage(error, 'Não foi possível carregar') })
      })
    return () => {
      alive = false
    }
    // `load` é recriada a cada render; quem chama controla a recarga por `key`.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key])
  return state
}
